import React from 'react'
import PropTypes from 'prop-types'
import clsx from 'clsx'

import { hasLocizeTranslation } from 'lib/utils/locize'
import { withI18next } from 'lib/i18n/withI18next'
import Typo from 'constants/typography'
import Icon from 'components/common/icon'
import { BUTTON_TYPES } from 'constants/button'
import Button from 'components/common/button'
import {
  HOW_TO_WORK_LIST,
  REFERRAL_LOCIZE,
} from 'components/referral/landing/const'
import ReferralCashBack from 'components/referral/landing/landing-desktop/cash-back'
import styles from './styles.scss'

const ReferralHowItWork = ({ referralInprogressFlagValue, t }) => (
  <div className="referral-how-it-work">
    <style jsx>{styles}</style>
    <div
      className={clsx('referral-how-it-work__wrapper', {
        inprogress: referralInprogressFlagValue,
      })}
    >
      <span className={clsx('referral-how-it-work__title', Typo.title2)}>
        {hasLocizeTranslation(
          t,
          REFERRAL_LOCIZE.REFERRAL_HOW_IT_WORK_TITLE.key,
          REFERRAL_LOCIZE.REFERRAL_HOW_IT_WORK_TITLE.text,
        )}
      </span>
      {HOW_TO_WORK_LIST.map((item, index) => (
        <div className="referral-how-it-work__list" key={index}>
          <Icon src={item.icon} size={item.iconSize} />
          <span className={clsx('referral-how-it-work__detail', Typo.body2)}>
            {hasLocizeTranslation(t, item.key, item.text)}
          </span>
        </div>
      ))}
      {!referralInprogressFlagValue && (
        <Button
          className="referral-how-it-work__credit-cta"
          type={BUTTON_TYPES.link}
          link
          aProps={{
            href: `/user/credits`,
            rel: 'noopener',
          }}
        >
          {hasLocizeTranslation(
            t,
            REFERRAL_LOCIZE.REFERRAL_CHECK_BALANCE.key,
            REFERRAL_LOCIZE.REFERRAL_CHECK_BALANCE.text,
          )}
        </Button>
      )}
    </div>
    {referralInprogressFlagValue && <ReferralCashBack />}
  </div>
)

ReferralHowItWork.propTypes = {
  referralInprogressFlagValue: PropTypes.bool.isRequired,
  t: PropTypes.func.isRequired,
}

export default withI18next()(ReferralHowItWork)
